import { Fragment } from 'react';
import { Chip } from '@mui/material';
import { useStyles } from '../../../themes';
import {
  paths,
  pathParams,
  nestedPages,
  generateValidatedParamsUrl,
} from '../../../lib';
import {
  AssignmentIcon,
  DashboardIcon,
  ListAltIcon,
  MaterialsIcon,
} from '../../../assets';
import { SidebarItem } from '../SidebarItem';
import { NestedList } from '../NestedList';

export function ProcessorSidebar({ handleClearSelectedOrders }) {
  const { css } = useStyles();
  return (
    <Fragment>
      <SidebarItem
        to={generateValidatedParamsUrl(paths.DESKTOP_HOME)}
        text='Home'
        icon={DashboardIcon}
      />
      <SidebarItem
        to={generateValidatedParamsUrl(paths.PROCESS_ORDER_HOME)}
        isActive={() =>
          window.location.pathname ===
          generateValidatedParamsUrl(paths.PROCESS_ORDER_HOME)
        }
        text={
          <span>
            Process Order{' '}
            <Chip
              size='small'
              label='Beta'
              classes={{ label: css({ fontSize: '10px !important' }) }}
            />
          </span>
        }
        icon={AssignmentIcon}
      />
      <NestedList text='Orders' icon={ListAltIcon} id='orders' defaultOpen>
        <SidebarItem
          text='Orders'
          to={generateValidatedParamsUrl(paths.ORDERS, {
            [pathParams.ORDER_TAB]: nestedPages.ORDERS_OPENED,
          })}
          isNested
          onClick={handleClearSelectedOrders}
          isActive={() => window.location.pathname.startsWith('/order')}
        />
        <SidebarItem
          text='Batches'
          isNested
          to={generateValidatedParamsUrl(paths.BATCH_LIST)}
          isActive={() =>
            window.location.pathname.startsWith(`/${paths.BATCH_LIST}`)
          }
        />
      </NestedList>
      <NestedList text='Shipping' icon={MaterialsIcon} id='shipping'>
        <SidebarItem
          to={generateValidatedParamsUrl(paths.GET_SP_ESTIMATE, {
            [pathParams.NESTED_PAGE]: nestedPages.SP_ESTIMATE,
          })}
          text='Browse Rates'
          isNested
          isActive={() =>
            window.location.pathname.startsWith('/small-parcel-estimate')
          }
        />
        {/* <SidebarItem
          to={generateValidatedParamsUrl(paths.PURCHASED_LABEL)}
          text='Labels & Rates'
          isNested
          isActive={() =>
            window.location.pathname.startsWith(`/${paths.PURCHASED_LABEL}`)
          }
        /> */}
        <SidebarItem
          to={generateValidatedParamsUrl(paths.SHIPPING_HISTORY)}
          text='Shipping history'
          isNested
          isActive={() =>
            window.location.pathname.startsWith(`/${paths.SHIPPING_HISTORY}`)
          }
        />
      </NestedList>
    </Fragment>
  );
}
